export function getLocalizedPath(path: string, locale: string, region?: 'eu' | 'uk' | 'us' | null): string {
  // Self-Co with region: always include both region and locale
  if (region) {
    const effectiveLocale = locale || 'de';

    return `/${region}/${effectiveLocale}${path}`;
  }

  // For default locales (Lithuanian for AllergoMedica/FoodID), no prefix needed
  if (locale === 'lt' || !locale) return path;

  return `/${locale}${path}`;
}
